import { Auth, AccessToken, Message } from "../../../domain/model/Auth";
import {
  FilterTrucksByModel,
  GenerateXmlFileResponse,
  Truck,
} from "../../../domain/model/Truck";
import { Response } from "../../api/Response";
import NetworkApi from "../../network/NetworkApi";
import { TruckRepository } from "./TruckRepository";

export class TruckRepositoryImpl implements TruckRepository {
  apiService: NetworkApi;

  constructor(datasource: NetworkApi) {
    this.apiService = datasource;
  }

  getAll(
    skip?: number,
    limit?: number,
    filterTrucksByModel?: FilterTrucksByModel
  ): Promise<Response<Array<Truck>>> {
    return this.apiService.getAllTrucks(skip, limit, filterTrucksByModel);
  }
  generateXmlFile(
    model?: FilterTrucksByModel,
    ids?: Array<string>
  ): Promise<Response<GenerateXmlFileResponse>> {
    return this.apiService.generateXmlFile(model, ids);
  }
}
